import React, {Component} from 'react'
import Resize from '../../_core/utils/Resize'

class Container extends Component {

  constructor() {
    super()
    this.state = {maxWidth:9999}
  }

  componentDidMount = () => {

    
    this.setWidth();
    


  }

  setWidth = () => {

    if(!this.refs['sizer']) return;

    let frame = this.refs['sizer'].offsetHeight;

    let canvasH = window.innerHeight - (frame * 2);
    let canvasW = window.innerWidth - (frame * 2);

    let ratio = canvasH / canvasW;

    let ratioFromHeight = 6/4;
    let ratioFromWidth = 4/6;
    let containerWidth = 9999;


    let scaledW = canvasH * ratioFromHeight;
  
    containerWidth = Math.min(canvasW,scaledW);

    if(window.innerWidth < 700){
      containerWidth = window.innerWidth * 0.9
    }

    

    /*if(ratio >= ratioFromHeight){

        // Use width
        containerWidth = canvasW;
    }else{

        // Scale from longest side
        let dim = (canvasW > canvasH) ? canvasH : canvasW;
        let ratio = dim == canvasH ? ratioFromHeight : ratioFromWidth;

        containerWidth = (canvasW < canvasH) ? canvasW : dim * ratio;

    }*/

    if(containerWidth == this.state.containerWidth) return;
    this.setState({maxWidth:containerWidth});


  }

  render () {
      return (
      <Resize onResize={this.setWidth}>
      <div className="Container">
        <div className="Container-sizer" ref="sizer" />
        <div className="Container-wrap" style={{maxWidth:this.state.maxWidth}}>
          {this.props.children}
        </div>
      </div>
      </Resize>
      )
  }
}

export default Container



// WEBPACK FOOTER //
// ./src/js/components/Container/Container.jsx